import * as React from 'react';
import Instagram from 'assets/instagram.inline.svg';
import Facebook from 'assets/facebook.inline.svg';
import LinkedIn from 'assets/linkedin.inline.svg';
import Twitter from 'assets/twitter.inline.svg';

export type SocialLinkType =
    | 'instagram'
    | 'linkedin'
    | 'facebook'
    | 'twitter'
    | 'tiktok'
    | 'spotify';

type SocialLink = {
    url: string;
    icon: React.ReactNode;
    type: SocialLinkType;
};

const socialLinks: ReadonlyArray<SocialLink> = [
    {
        url: 'https://linkedin.com/company/bondvet',
        icon: <LinkedIn role="img" aria-label="LinkedIn logo" />,
        type: 'linkedin',
    },
    {
        url: 'https://instagram.com/bondvetclinic/',
        icon: <Instagram role="img" aria-label="Instagram logo" />,
        type: 'instagram',
    },
    {
        url: 'https://facebook.com/bondvetclinic',
        icon: <Facebook role="img" aria-label="Facebook logo" />,
        type: 'facebook',
    },
    {
        url: 'https://twitter.com/BondVetClinic',
        icon: <Twitter role="img" aria-label="X logo" />,
        type: 'twitter',
    },
    {
        url: 'https://tiktok.com/@bondvet',
        icon: null,
        type: 'tiktok',
    },
    {
        url: 'https://open.spotify.com/show/4AIJs2MckrrFfwWj6qMrew',
        icon: null,
        type: 'spotify',
    },
];

export default socialLinks;
